import { render } from "./MonitoringActiveFlowsPage.vue?vue&type=template&id=7c31370b&scoped=true"
import script from "./MonitoringActiveFlowsPage.vue?vue&type=script&lang=js"
export * from "./MonitoringActiveFlowsPage.vue?vue&type=script&lang=js"

import "./MonitoringActiveFlowsPage.vue?vue&type=style&index=0&id=7c31370b&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c31370b"]])

export default __exports__